import { indexItems } from '@/mocks/home';

export default function SectionIndex() {
  return (
    <section id="index" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
          <i className="ri-folder-open-line text-primary-500 mr-2"></i>
          主题合集
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer group"
            >
              <span className="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-primary-100 text-primary-600 rounded-xl text-xl transition-colors duration-200 group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={item.icon}></i>
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-1 group-hover:text-primary-600 transition-colors duration-200 truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 truncate">{item.desc}</p>
              </div>
              <span className="flex-shrink-0 px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full whitespace-nowrap">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}